export default __webpack_public_path__ + "static/media/real-estate.4ae25a59.jpg";